import TopHeadScreen from "../../component/layout/tophead";
import SidebarScreen from "../../component/layout/sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { HiOutlineLightBulb } from "react-icons/hi";
import { CiUser } from "react-icons/ci";
import { BsBriefcase } from "react-icons/bs";
import { SlGraduation } from "react-icons/sl";
import { LiaAwardSolid } from "react-icons/lia";
import { Formik, FormikHelpers } from "formik";
import { useEffect, useState } from "react";
import { ResumeAboutYouSchema } from "../../validation/validator";
import { Spinner } from "react-bootstrap";
import { AppRoute } from "../../router/routerConstants";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addResumeToList, clearAllResumes, clearResumeDetails, ResumeDetails, setResumeDetails } from "../../store/resume.store";
import { RootState } from "../../store/store";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import AgentSidebarScreen from "../../component/layout/agent-sidebar";
import AgentTopHeadScreen from "../../component/layout/agent-header";
import { resumelistForAgentWOApplication } from "../../service/apis/auth.api";
interface AboutMyResume {
  selectedResume: string,
  name: string;
  bio: string;
}
const ProfileMyResumeScreen = () => {
  const [NavigateTo] = useCustomNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();

  const { resumeDetails,resumeList } = useSelector(
    (state: RootState) => state.resumeSlice
  );
  const preSelectedResumeId = state?.editId || "";
  // console.log(resumeDetails,8777);
  
  const [selectedResume]=useState<string>(preSelectedResumeId || '');
  
  const { user } = useSelector((state: RootState) => state.authSlice);

  const [stateDetails, setState] = useState({
    selectedResume:"",
    name: "",
    bio: "",
  });

  useEffect(() => {
    const fullName =
      user &&
      user?.role === "jobseeker" &&
      user?.firstName + " " + user?.lastName;

    setState({
      selectedResume: preSelectedResumeId || resumeDetails?._id || "",
      name: resumeDetails?.name || fullName || "",
      bio: resumeDetails?.bio || "",
    });

    if(user && user?.role === "localagents")
    {
       resumelistForAgentForEdit();
    }
    // eslint-disable-next-line
  }, [user, resumeDetails]);

  const resumelistForAgentForEdit = async () =>
  {
    const response = await resumelistForAgentWOApplication();
            // console.log(response, "response resume list");
            const updatedDetails = {
              resumeDetails:
                response?.data?.filteredResumes &&
                response?.data?.filteredResumes?.map((resumeDetail: any) => ({
                  name: resumeDetail?.resume?.resumeData?.name,
                  bio: resumeDetail?.resume?.resumeData?.bio,
                  email: resumeDetail?.resume?.resumeData?.email,
                  explevel: resumeDetail?.resume?.resumeData?.explevel,
                  contact: resumeDetail?.resume?.resumeData?.contact,
                  experiences: resumeDetail?.resume?.resumeData?.experiences,
                  skills: resumeDetail?.resume?.resumeData?.skills,
                  achievements: resumeDetail?.resume?.resumeData?.achievements,
                  educations: resumeDetail?.resume?.resumeData?.educations,
                  resumeLink: resumeDetail?.resume?.resumeLink,
                  _id: resumeDetail?._id,
                })),
            };
            dispatch(clearAllResumes());
            // console.log(updatedDetails);
            if(updatedDetails.resumeDetails?.length>0)
            {
              updatedDetails.resumeDetails.forEach((resumeDetail: ResumeDetails) => {
                dispatch(addResumeToList(resumeDetail));
              });
            }
  }

  const handleFormSubmit = (
    values: AboutMyResume,
    { setSubmitting }: FormikHelpers<any>
  ) => {
    if (values) {
      setState(values);
      let contact = user?.phone;
      let email = user?.email;
      let jobId = state?.jobId;
      // let explevel = state?.explevel;

      const newDetails = { ...resumeDetails };
      
      if (
        user?.role === "localagents" &&
        (!selectedResume || values?.selectedResume?.trim() === "")
      ) {
        delete newDetails._id;
      }

      if (
        selectedResume &&
        user?.role === "localagents" &&
        values?.selectedResume?.trim() !== ""
      ) {
        newDetails._id = values.selectedResume;
      }

      const updatedDetails = {
        ...newDetails,
        name: values?.name,
        bio: values?.bio,
        contact: contact || "",
        email: email || "",
        jobId: jobId || "",
        // explevel: explevel || false,
      };

      
      // console.log(updatedDetails);
      

      dispatch(setResumeDetails(updatedDetails));

      if (user && user?.role === "jobseeker") {
        if (
          resumeDetails?.experiences &&
          resumeDetails?.experiences?.length > 0
        )
          NavigateTo(AppRoute.JOBSEEKER_ADDED_WORK_EXPERIENCE);
        else NavigateTo(AppRoute.JOBSEEKER_WORK_EXPERIENCE);
      } else if (user && user?.role === "localagents") {
        // console.log(selectedResume,preSelectedResumeId,7777);
        if (
          (resumeDetails?.experiences &&
          resumeDetails?.experiences?.length > 0) || selectedResume
        )
          NavigateTo(AppRoute.AGENT_ADDED_WORK_EXPERIENCE,false,{...((selectedResume) && { editId: selectedResume })});
        else NavigateTo(AppRoute.AGENT_WORK_EXPERIENCE);
      }
    }
    setSubmitting(false);
  };
  // console.log(resumeList);
  

  return (
    <>
      <div className="main">
        <section className="profileJobDetails-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar  position-relative p-0">
                {user && user?.role === "jobseeker" && <SidebarScreen />}
                {user && user?.role === "localagents" && <AgentSidebarScreen />}
              </div>
              <div className="col-lg-10 rightcontent p-0">
                {user && user?.role === "jobseeker" && <TopHeadScreen />}
                {user && user?.role === "localagents" && <AgentTopHeadScreen />}

                <div className="profile-account-details-holder rightInnerScroll  common-padd-lt-rt ">
                  <div className="row">
                    <div className="col-lg-12 mb-4">
                      <div className="profile-account-details">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="title">
                              <h2>My Resume</h2>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="myResume-holder">
                              <div className="login-form-area add-password-form mt-5">
                                <Formik
                                  onSubmit={handleFormSubmit}
                                  initialValues={stateDetails}
                                  validationSchema={ResumeAboutYouSchema}
                                  enableReinitialize={true}
                                >
                                  {({
                                    values,
                                    handleChange,
                                    handleBlur,
                                    touched,
                                    errors,
                                    isSubmitting,
                                    handleSubmit,
                                    setFieldValue,
                                  }) => 
                                  {
                                    const handleResumeChange = async  (e: React.ChangeEvent<HTMLSelectElement>) => {
                                      const selectedResumeId = e.target.value;

                                        const selectedResume = resumeList.find(resume => resume._id === selectedResumeId);

                                        if (selectedResume) {

                                          const name = selectedResume?.name || '';
                                          const bio = selectedResume?.bio || '';                                          
                                          await dispatch(setResumeDetails({ ...selectedResume, name, bio }));

                                        } else {
                                          dispatch(clearResumeDetails());
                                        }
                                    };



                                    return (
                                    <Form noValidate onSubmit={handleSubmit}>
                                      <div className="stepbar">
                                        <ul>
                                          <li className="inprogress">
                                            <a href="/jobseeker/my-resume">
                                              <div className="icon-progress">
                                                <span>
                                                  <CiUser />
                                                </span>
                                              </div>
                                              <p>Step 1</p>
                                              <h4>About You</h4>
                                            </a>
                                          </li>
                                          <li className="">
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                            <a href="#">
                                              <div className="icon-progress">
                                                <span>
                                                  <BsBriefcase />
                                                </span>
                                              </div>
                                              <p>Step 2</p>
                                              <h4>Experience</h4>
                                            </a>
                                          </li>
                                          <li className="">
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                            <a href="#">
                                              <div className="icon-progress">
                                                <span>
                                                  <SlGraduation />
                                                </span>
                                              </div>
                                              <p>Step 3</p>
                                              <h4>Education</h4>
                                            </a>
                                          </li>
                                          <li className="">
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                            <a href="#">
                                              <div className="icon-progress">
                                                <span>
                                                  <LiaAwardSolid />
                                                </span>
                                              </div>
                                              <p>Step 4</p>
                                              <h4>Achievements</h4>
                                            </a>
                                          </li>
                                          <li className="">
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                            <a href="#">
                                              <div className="icon-progress">
                                                <span>
                                                  <HiOutlineLightBulb />
                                                </span>
                                              </div>
                                              <p>Step 5</p>
                                              <h4>Skills</h4>
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                      <h3>Your Details</h3>
                                      <div className="row">
                                        {user?.role === "localagents" && (
                                        <div className="col-lg-4">
                                          <Form.Group className="mb-3 position-relative">
                                            <Form.Label>Update Resume For</Form.Label>
                                            <Form.Select 
                                                aria-label="Select Resume"
                                                onChange={handleResumeChange}
                                                value={values?.selectedResume}
                                                name="selectedResume"
                                                className="updatedResume"
                                              >
                                                <option value="">Create new</option>
                                                {resumeList &&
                                                  resumeList?.map((user: any, index: number) => (
                                                      <option value={user?._id} key={index}>{user.name}</option>
                                                ))}
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                              {touched.selectedResume && errors.selectedResume}
                                            </Form.Control.Feedback>
                                          </Form.Group>
                                        </div>
                                        )}
                                        <div className="col-lg-4">
                                          <Form.Group className="mb-3 position-relative">
                                            <Form.Label>Your Name</Form.Label>
                                            <Form.Control
                                              type="text"
                                              name="name"
                                              placeholder="Makenna Levin"
                                              onBlur={handleBlur}
                                              onChange={(e) => handleChange(e)}
                                              value={values.name}
                                              isInvalid={
                                                touched.name && !!errors.name
                                              }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                              {touched.name && errors.name}
                                            </Form.Control.Feedback>
                                          </Form.Group>
                                        </div>
                                        <div className="col-lg-9">
                                          <Form.Group className="mb-3 position-relative">
                                            <Form.Label>Your Bio</Form.Label>
                                            {/* <Form.Control
                                              as="textarea"
                                              placeholder="It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc."
                                            /> */}
                                            <Form.Control
                                              type="textarea"
                                              name="bio"
                                              placeholder="It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc."
                                              onBlur={handleBlur}
                                              onChange={(e) => handleChange(e)}
                                              value={values.bio}
                                              isInvalid={
                                                touched.bio && !!errors.bio
                                              }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                              {touched.bio && errors.bio}
                                            </Form.Control.Feedback>
                                          </Form.Group>
                                        </div>
                                        <div className="col-lg-9">
                                          <div className="btn-holder">
                                            <Button
                                              type="submit"
                                              className="btn btn-primary"
                                              variant="primary"
                                            >
                                              {isSubmitting ? (
                                                <Spinner
                                                  animation="border"
                                                  size="sm"
                                                  role="status"
                                                  aria-hidden="true"
                                                />
                                              ) : (
                                                "Next"
                                              )}
                                            </Button>
                                          </div>
                                        </div>
                                      </div>
                                    </Form>
                                  )
                                }
                                  }
                                </Formik>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />
    </>
  );
};
export default ProfileMyResumeScreen;
